

















































import CCustomSelect from '~/components/shared/configurable/form/select/custom/CCustomSelect.vue'
import { defineComponent, ref, watch, computed } from '~/utils/nuxt3-migration'
import useClassifiedSearchFacet from '~/compositions/classified-search/useClassifiedSearchFacet'
import { facetHandlerComponentProps } from '~/constants/classified/search/facet'
import { Searchable } from '~/models/search/types'

export default defineComponent({
  components: { CCustomSelect },
  props: facetHandlerComponentProps,
  setup(props) {
    const { changeParams } = useClassifiedSearchFacet()

    const selectedMakes = ref(props.selected.makes || [])
    const selectedModels = ref(props.selected.models || [])

    const makesOptions = computed(() =>
      (props.searchables.makes || []).map((s: Searchable) => ({
        value: s.v,
        label: s.n
      }))
    )

    const modelsOptions = computed(() =>
      (props.searchables.models || []).map((s: Searchable) => ({
        value: s.v,
        label: s.n
      }))
    )

    watch(
      () => props.selected,
      selected => {
        selectedMakes.value = selected.makes || []
        selectedModels.value = selected.models || []
      }
    )

    function onClearMakeClick() {
      selectedMakes.value = []
      selectedModels.value = []

      changeParams([
        {
          name: 'manufacturer',
          value: null
        },
        {
          name: 'product_model',
          value: null
        }
      ])
    }

    function onClearModelClick() {
      selectedModels.value = []

      changeParams([
        {
          name: 'product_model',
          value: null
        }
      ])
    }

    function onMakeChange(value: number[]) {
      changeParams([
        {
          name: 'manufacturer',
          value
        }
      ])
    }

    function onModelsChange(value: number[]) {
      changeParams([
        {
          name: 'product_model',
          value
        }
      ])
    }

    return {
      selectedMakes,
      selectedModels,
      makesOptions,
      modelsOptions,
      onMakeChange,
      onModelsChange,
      onClearMakeClick,
      onClearModelClick
    }
  }
})
